let collapses = document.querySelectorAll('[data-control-collapse]');

for(let collapse of collapses) {
    let id = collapse.getAttribute('data-control-collapse');

    let toggles = document.querySelectorAll(`[href="#${id}"]`);
    for(let toggle of toggles) {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();

            collapse.classList.toggle('open');

            if(collapse.classList.contains('open')) {
                toggle.innerHTML = toggle.innerHTML.replace('Start', 'Hide');
            }
            else {
                toggle.innerHTML = toggle.innerHTML.replace('Hide', 'Start');
            }
        });
    }
}